import { createContext, useContext, useState, useEffect } from "react";
import { getRedirectUrl } from "__utils/helpers.js";

import { buildAssetPath, changeFaviconAndTitle, getUrlParams } from "__utils/helpers.js";
import useWindowSize from "__hooks/screensize-hook";
import { useAuth } from "__hooks/auth-hook";

const GlobalContext = createContext();

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalContextProvider = ({ componentName, children }) => {
	const urlParams = getUrlParams();
	const windowSize = useWindowSize();

	changeFaviconAndTitle(urlParams.game);

	const redirectUrl = getRedirectUrl(urlParams);

	const [baseAssetPath, setBaseAssetPath] = useState(
		buildAssetPath(windowSize.width, windowSize.height, componentName, urlParams)
	);
	const { user, login } = useAuth();

	const contextValue = {
		...urlParams,
		baseAssetPath,
		redirectUrl,
		user,
		login,
	};

	useEffect(() => {
		setBaseAssetPath(buildAssetPath(windowSize.width, windowSize.height, componentName, urlParams));
	}, [windowSize, componentName, urlParams]);

	return <GlobalContext.Provider value={contextValue}>{children}</GlobalContext.Provider>;
};
